import Call from "assets/call.svg";
import Download from "assets/download.svg";
import Locator from "assets/locator.svg";
import Steer from "assets/steer.svg";
import { useLanguage } from "LanguageContext";
import Broucher from "Pages/components/Broucher";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "ReusableComponents/Box";
import { WEIGHT } from "theme";
import { TextStyled } from "../../ReusableComponents/Text/styles";

const Banner = ({ small, medium }) => {
  const { t } = useTranslation();

  const { selectedLanguage } = useLanguage();

  const [open, setOpen] = useState(false);
  const [isSmallMedium, setIsSmallMedium] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const boxes = [
    {
      label: "Charging Hub Locator",
      image: Locator,
      link: "/charging-network",
    },
    {
      label: "Call Us 1800 1238 1238",
      image: Call,
      link: "tel:1800 1238 1238",
    },
    {
      label: "Book a Test Ride",
      image: Steer,
      action: () => (window.location.href = `/${selectedLanguage}/test-ride`),
    },
    {
      label: "Download Brochure",
      image: Download,
      action: () => setOpen(true),
    },
  ];

  const slideIntervalRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallMedium(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Start the automatic sliding after initial render
    startSlide();

    // Cleanup the slide interval on component unmount
    return () => {
      stopSlide();
    };
  }, []);

  const startSlide = () => {
    stopSlide(); // Stop any existing slide interval

    slideIntervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % boxes.length);
    }, 5000);
  };

  const stopSlide = () => {
    clearInterval(slideIntervalRef.current);
  };

  const renderBox = (box) => {
    return (
      <Box
        display="flex"
        alignItems="center"
        cursor={box.action ? "pointer" : "default"}
        onClick={box.action || undefined}
      >
        <img src={box.image} alt={box.label} style={{ marginRight: 8 }} />
        <TextStyled fontSize="16px" margin="0" fontWeight={WEIGHT.bold}>
          <a href={box.link}> {t(box.label)}</a>
        </TextStyled>
      </Box>
    );
  };

  return (
    <Box
      h="56px"
      padding={small ? "0 20px" : "0 80px"}
      display="flex"
      alignItems="center"
      justifyContent={small || medium ? "center" : "space-between"}
      position="fixed"
      left="0"
      right="0"
      bottom="0"
      zIndex="12"
      background="#9CCDFB"
    >
      {small || medium ? (
        <>{renderBox(boxes[currentIndex])}</>
      ) : (
        <>
          {boxes.map((box, index) => (
            <React.Fragment key={index}>{renderBox(box)}</React.Fragment>
          ))}
        </>
      )}

      {open && <Broucher open={open} handleClose={() => setOpen(false)} />}
    </Box>
  );
};

export default Banner;
